import { constants, typographyStyles } from "@newsela/angelou";

import { flexboxAlignItemsCenterCss } from "@/components/components.style";

const { heading4Obj, textXSObj } = typographyStyles;

const { ui } = constants.colors;

export const contentCardCss = (adjustYFp) => ({
  ...(adjustYFp && {
    "& > div > div:first-child > img": {
      objectPosition: "top",
    },
  }),
  ":hover": {
    h2: {
      textDecorationColor: "transparent",
    },
  },
});

export const contentTypeContainerCss = [
  flexboxAlignItemsCenterCss,
  {
    lineHeight: "1em",
  },
];

export const externalLinkIconCss = {
  g: { stroke: ui.neutral[400] },
  width: "1.2em",
  marginLeft: "3px",
};

export const externalLinkCardFooterCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const labelCss = {
  color: ui.neutral[400],
  marginBottom: "8px",
};

export const lessonsCardCss = {
  cursor: "pointer",
};

export const customContentTypeAndFeaturesRowCss = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  marginBottom: "8px",
  textTransform: "uppercase",
  ...textXSObj,
};

export const contentLabelStyle = {
  color: ui.neutral[400],
  textTransform: "uppercase",
  margin: 0,
};

export const queryContentCardCss = (seasonalMultiEntity) => ({
  borderRadius: seasonalMultiEntity ? "16px" : "4px",
  "&>div": {
    gridTemplateRows: "3fr 1fr auto",
  },
  "&>div :nth-child(2)": {
    paddingBottom: seasonalMultiEntity ? "10px" : "none",
  },
  "&>div :nth-child(3)": {
    display: seasonalMultiEntity ? "none" : "flex",
  },
  "&>a::after": {
    borderRadius: seasonalMultiEntity ? "16px !important" : "4px",
  },
});

export const lastestVideoCardCss = (isPopularContent) => ({
  backgroundColor: `${
    isPopularContent ? ui.white[700] : ui.neutral[700]
  } !important`,
  borderRadius: 16,
  borderWidth: isPopularContent ? 1 : 0,
  "&>a:first-of-type:after": {
    borderRadius: 16,
  },
  "&>div :nth-child(2)": {
    justifyContent: "flex-start",
    h3: {
      margin: "8px 0px",
      overflow: "hidden",
      color: isPopularContent ? ui.neutral[600] : ui.neutral[100],
      textOverflow: "ellipsis",
      ...heading4Obj,
      fontWeight: 700,
    },
  },
  "&>div :nth-child(3)": {
    "&>div": {
      display: "flex",
      justifyContent: "flex-end",
    },
    "&>div :nth-child(1)": !isPopularContent && {
      ":hover": {
        background: "rgb(255, 255, 255, 0.20)",
        cursor: "pointer",
      },
    },
  },
});

export const bookmarkWrapperCss = {
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end",
  zIndex: 99,
};

export const queryContentSearchIconCss = {
  width: "19px",
  marginTop: "-10px",
  marginRight: "5px",
  "& > :first-child": {
    color: ui.neutral[700],
  },
};

export const queryContentTitleCss = (seasonalMultiEntity) => ({
  ...heading4Obj,
  lineHeight: 1.2,
  margin: "0 0 8px",
  wordBreak: "break-word",
  fontWeight: seasonalMultiEntity ? "700" : "normal",
});

export const queryContentCss = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  marginLeft: "24px",
  marginRight: "24px",
  marginTop: "16px",
  gridArea: "textual",
};

export const contentCardTextualCss = {
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
};

export const readingSkillsCss = {
  display: "flex",
  padding: "1rem",
  flexDirection: "column",
  alignItems: "flex-start",
};

export const contentCardTextualDateCss = {
  display: "flex",
  alignItems: "flex-start",
  color: constants.colors.ui.neutral[400],
  marginTop: "10px",
  paddingLeft: "1.5rem",
  paddingTop: "0.5rem",
  fontFamily: "Circular",
  fontSize: "0.75rem",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "1rem",
  letterSpacing: "0.00806rem",
};

export const topTextCss = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: "0.5rem",
  paddingRight: "0.5rem",
  paddingBottom: "1rem",
};

export const kindOfTopicCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  height: "16px",
  color: constants.colors.ui.neutral[400],
  fontFamily: "Circular",
  fontSize: "0.75rem",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "2rem",
  textTransform: "uppercase",
};

export const contentTypeLeft = {
  display: "flex",
  alignItems: "flex-start",
};

export const contentTypeRight = {
  display: "flex",
  alignItems: "flex-end",
  gap: "3px",
  svg: {
    height: "1rem",
    width: "1rem",
  },
};

export const titleCss = {
  color: constants.colors.ui.neutral[600],
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontFamily: "Circular",
  fontSize: "1.25rem",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "1.2rem",
  height: "2.5rem",
  display: "-webkit-box",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
};

export const readingSkillsChipsCss = {
  display: "flex",
  gap: "0.5rem",
  height: "4rem",
  alignItems: "flex-start",
  alignContent: "flex-start",
  alignSelf: "stretch",
  flexWrap: "wrap",
  ">ul": {
    alignItems: "flex-start",
  },
};

export const readingSkillsChipsGroupCss = {
  root: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    flexWrap: "wrap",
    color: constants.colors.ui.neutral[700],
    fontFamily: "Circular",
    fontSize: "0.875rem",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "171%",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",

    ">li": {
      maxWidth: "fit-content",
      height: "auto",
      border: "none",
      backgroundColor: constants.colors.ui.neutral[50],
      ":hover": {
        backgroundColor: constants.colors.ui.neutral[50],
      },
      "> label > span": {
        position: "relative",
        overflow: "visible",
        color: constants.colors.ui.neutral[700],
      },
    },
  },
};
